import React from 'react';
import { Calendar, Info } from 'lucide-react';

/**
 * Компонент боковой панели с информацией о праздниках в России
 */
const HolidaysInfoSidebar = () => {
  // Список государственных праздников РФ
  const russianHolidays = [
    { date: "1-8 января", name: "Новогодние каникулы" },
    { date: "7 января", name: "Рождество Христово" },
    { date: "23 февраля", name: "День защитника Отечества" },
    { date: "8 марта", name: "Международный женский день" },
    { date: "1 мая", name: "Праздник Весны и Труда" },
    { date: "9 мая", name: "День Победы" },
    { date: "12 июня", name: "День России" },
    { date: "4 ноября", name: "День народного единства" }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Calendar className="w-5 h-5 mr-2 text-red-500" />
        Праздничные дни России
      </h3>
      
      <div className="space-y-3">
        {russianHolidays.map((holiday, index) => (
          <div 
            key={index} 
            className="flex items-start p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <div className="w-10 h-10 flex-shrink-0 bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-full flex items-center justify-center mr-3">
              <span className="font-bold text-sm">{holiday.date.split(' ')[0]}</span>
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white">
                {holiday.name}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {holiday.date}
              </p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start">
          <Info className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-1">
              Производственный календарь
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              При расчетах учитываются все государственные праздники 
              и перенесенные выходные дни согласно производственному календарю РФ. 
              Календарь автоматически обновляется в соответствии с постановлениями правительства.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidaysInfoSidebar;